import { render, staticRenderFns } from "./ApplicantTracking.vue?vue&type=template&id=2b534a86&scoped=true"
import script from "./ApplicantTracking.vue?vue&type=script&lang=js"
export * from "./ApplicantTracking.vue?vue&type=script&lang=js"
import style0 from "./ApplicantTracking.vue?vue&type=style&index=0&id=2b534a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b534a86",
  null
  
)

export default component.exports